module.exports = "<router-outlet></router-outlet>\n<!--<enrich-route-migration>-->\n  <!--<div data-ui-view=\"\" data-autoscroll=\"false\" data-ng-class=\"mainViewAnimation\" class=\"wrapper\"></div>-->\n<!--</enrich-route-migration>-->\n<toaster-container [toasterconfig]=\"toasterConfig\"></toaster-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main